module.exports = __webpack_public_path__ + "img/kaituan.16d37fa8.png";